import { drConfig } from "./drConfig";

export class UserGrid
{
    userId: number;
    ownerId: number;
    storeId: number;
    userType: number;
    code: string;
    name: string;
    surname: string;
    company: string;
    nickname: string;
    image: string;
    email: string;
    mobile: string;
    country: string;
    login: string;
    password: string;
    count1: number;

    hasApp: boolean;

    isFriend: boolean;
    isSelected: boolean;

    constructor() {
        this.userId = 0;
        this.ownerId = 0;
        this.storeId = 0;
        this.userType = 0;
        this.code = '';
        this.name = '';
        this.surname = '';
        this.company = '';
        this.nickname = '';
        this.image = '';
        this.email = '';
        this.mobile = '';
        this.country = '';
        this.login = '';
        this.password = '';
        this.count1 = 0;
        this.hasApp = false;
        this.isFriend = false;
        this.isSelected = false;
    }
}

export class GetUsersGridResp
{
    error: string = '';
    groupName: string = '';
    users: UserGrid[] = [];
}
export class GetUsersGridReq
{
    myToken: string;
    searchText: string;
    groupId: number;
    sez: string;
    constructor() {
        this.myToken = '';
        this.searchText = '';
        this.sez = '';
        this.groupId = 0;
    }
}
export class CreateUserGridReq {
    myToken: string;
    user: UserGrid;
    groupId: number;
    family: string;
    operatori: boolean;

    constructor() {
        this.myToken = '';
        this.user = new UserGrid();
        this.groupId = 0;
        this.family = '';
        this.operatori = false;
    }
}

export class MoveContactsReq {
    myToken: string;
    ids: string;
    groupId: number;
    family: string;

    constructor() {
        this.myToken = '';
        this.ids = '';
        this.groupId = 0;
        this.family = '';
    }
}
export class MoveContactsResp {
    error: string;
    tot: number;

    constructor() {
        this.error = '';
        this.tot = 0;
    }
}
